import {Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {FX} from 'app/core/domain/fx';
import {FxService} from '../../../core/service/fx.service';

@Component({
    selector: 'fxs-list',
    templateUrl: './fxs-list.component.html',
    styleUrls: ['./fxs-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FxsListComponent implements OnInit {

    @Input() fxsList: FX[] = [];

    @Output() fxsListChange = new EventEmitter<FX[]>();

    @Input() title = '';

    @Input() actionIcon = '';

    @Input() globalFilter = true;

    @Output() onFxSelected = new EventEmitter<FX>();

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {

    }

    public getSelectedFX(fx) {
        fx = new FX(fx);
        const i: number = this.buscarFX(this.fxsList, fx);

        /** FIX: para que detecte el cambio del arreglo  */
        this.fxsList.splice(i, 1);
        const list: FX[] = this.fxsList;
        this.fxsList = list.concat([]);
        /** END - FIX */

        this.onFxSelected.emit(fx);
        this.fxsListChange.emit(this.fxsList);
    }

    public buscarFX(fxs: FX[], search: FX ): number{
        for (let i = 0; i < fxs.length; i++) {
            if (fxs[i].equals(search)) {
                return i;
            }
        }
        return -1;
    }

    public update() {
        this.cd.markForCheck();
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/fxs/fxs-list/fxs-list.component.ts